import { mergeClassnames } from '@heathmont/moon-core-tw';
import LineWrapper from './styles/LineWrapper';
import ToggleCaption from '../shared/ToggleCaption';
import OtherClaps from '@/external/icons/OtherClaps';

type Props = { isLiked: boolean; total?: number; onClick: () => void };

const ToggleMobile: FC<Props> = ({ isLiked, total, onClick }) => (
  <div
    className={mergeClassnames(
      'grid gap-1',
      isLiked ? 'text-piccolo' : 'text-trunks',
    )}
    id="clapp-toggle"
  >
    <LineWrapper>
      <div
        className="z-2 mx-auto my-0 flex h-[3.75rem] w-[3.75rem] items-center justify-center rounded-full bg-gohan"
        onClick={onClick}
      >
        <OtherClaps className="text-moon-32" />
      </div>
    </LineWrapper>
    <span className="text-center text-moon-10-caption font-medium uppercase">
      <ToggleCaption total={total} />
    </span>
  </div>
);

export default ToggleMobile;
